import React, { useState } from 'react';
import {
    ClosingDateActionForm,
    ClosingDateActionMode,
} from './ClosingDateActionForm';

export interface ClosingDateActionControlsProps {
    engagementId: number;
    canPropose: boolean;
    canRespond: boolean;
    proposalId?: string | null;
    proposalDate?: string | null;
    earliestClosingDate?: string | null;
    earliestClosingDateStepName?: string | null;
    flowOfFundsRecommendedClosingDate?: string | null;
}

export const ClosingDateActionControls = ({
    engagementId,
    canPropose,
    canRespond,
    proposalId,
    proposalDate,
    earliestClosingDate,
    earliestClosingDateStepName,
    flowOfFundsRecommendedClosingDate,
}: ClosingDateActionControlsProps) => {
    const [activeAction, setActiveAction] =
        useState<ClosingDateActionMode | null>(null);

    if (!canPropose && !canRespond) {
        return null;
    }

    if (activeAction) {
        return (
            <ClosingDateActionForm
                engagementId={engagementId}
                mode={activeAction}
                proposalId={proposalId}
                proposalDate={proposalDate}
                earliestClosingDate={earliestClosingDate}
                earliestClosingDateStepName={earliestClosingDateStepName}
                flowOfFundsRecommendedClosingDate={
                    flowOfFundsRecommendedClosingDate
                }
                onCancel={() => setActiveAction(null)}
                onDone={() => setActiveAction(null)}
            />
        );
    }

    return (
        <div className="closing-date-action-controls">
            {canRespond && (
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => setActiveAction('accept')}>
                    Accept
                </button>
            )}
            {canRespond && (
                <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => setActiveAction('decline')}>
                    Decline
                </button>
            )}
            {canPropose && (
                <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => setActiveAction('propose')}>
                    Propose New Date
                </button>
            )}
        </div>
    );
};
